import NotFoundState from '@rio-cloud/rio-uikit/NotFoundState';
import { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';

export const EmptyResultMessage: FunctionComponent = () => (
    <NotFoundState
        headline={<FormattedMessage id="outboundOrderBook.inspector.dataquery.emptyResult" />}
        outerClassName="border-none"
    />
);
